import React from 'react'
import { Tooltip } from '@mui/material'
import { deburr, isArray, isNil, isObject, replace, toLower, trim } from 'lodash'
import { PASTEL_COLOR } from './ColorUtil'
import { hasValue } from './NumberUtil'

const normalizeString = (str = '') => replace(trim(deburr(toLower(str))), /[^a-z0-9]/g, '')

const isJson = (string) => {
    try {
        const json = JSON.parse(string)
        return isObject(json) || isArray(json)
    } catch {
        return false
    }
}

const getIconPriority = (priority) => {
    if (priority === 'Bloquante') return { icon: 'local_fire_department', color: PASTEL_COLOR.red, sortValue: 1 }
    if (priority === 'Urgente') return { icon: 'new_releases', color: PASTEL_COLOR.orange, sortValue: 2 }
    if (priority === 'Majeure') return { icon: 'error', color: PASTEL_COLOR.yellow, sortValue: 3 }
    if (priority === 'Elevée') return { icon: 'play_circle', color: PASTEL_COLOR.green, sortValue: 4 }
    if (priority === 'Mineure') return { icon: 'hourglass_bottom', color: PASTEL_COLOR.blue, sortValue: 5 }
    if (priority === 'Basse') return { icon: 'local_cafe', color: PASTEL_COLOR.grey, sortValue: 6 }
    return {}
}

const formatMilliers = (nb, showDecimals) => {
    const string = `${hasValue(nb) ? nb : ''}`
    const x = string.split('.')
    let x1 = x[0]
    const x2 = showDecimals && x.length > 1 ? `.${x[1]}` : ''
    const rgx = /(\d+)(\d{3})/
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ' ' + '$2')
    }
    return x1 + x2
}

const truncateString = (str, limit) => {
    if (str.length <= limit) {
        return str
    }
    return `${str.slice(0, limit)}...`
}

// Tronque un texte au-delà de shortNumber caractères ; affiche la valeur complète en tooltip
// (sauf si noTooltip). Repris de SIEau (utils/StoreUtils).
const getTruncate = (text, shortNumber = 50, noTooltip = false) => {
    if (isNil(text)) return ''
    if (text.length < shortNumber) return text
    if (noTooltip) return `${text.slice(0, shortNumber)}...`
    return <Tooltip title={text}>{`${text.slice(0, shortNumber)}...`}</Tooltip>
}

const removePipes = (str) => {
    if (str !== undefined) {
        const cleaned = str.trim()
        const withoutStart = cleaned.startsWith('|') ? cleaned.slice(1).trim() : cleaned
        return withoutStart.endsWith('|') ? withoutStart.slice(0, -1).trim() : withoutStart
    }
}

export {
    normalizeString,
    isJson,
    getIconPriority,
    formatMilliers,
    truncateString,
    getTruncate,
    removePipes,
}
